{
  "altitude": {
    "displayName": "Altitude",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "applicationRateEstimatedMm": {
    "displayName": "Application"
  },
  "applicationRateReportsMm": {
    "displayName": "Application",
    "unitLabel": {
      "metric": "mm",
      "us": "dans"
    }
  },
  "calibrationIntercept": {
    "displayName": "Interception d'étalonnage"
  },
  "calibrationSlope": {
    "displayName": "Pente d'étalonnage"
  },
  "configurationId": {
    "displayName": "ID de configuration"
  },
  "currentPercentage": {
    "displayName": "Pourcentage actuel"
  },
  "deviceFunctionCall": {
    "displayName": "Appel de fonction de l'appareil"
  },
  "deviceFunctionCallId": {
    "displayName": "causeId"
  },
  "diameterMm": {
    "displayName": "Diamètre de la roue",
    "instructions": "Mesurez le diamètre (distance la plus large entre deux côtés de la roue).",
    "unitLabel": {
      "metric": "mm",
      "us": "dans"
    }
  },
  "distanceObservedMm": {
    "displayName": "Distance",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "flowRateEstimatedLpm": {
    "displayName": "Débit",
    "unitLabel": {
      "metric": "l/min",
      "us": "gallons/min"
    }
  },
  "gpsType": {
    "displayName": "Modèle de puce GPS"
  },
  "heading": {
    "displayName": "Titre",
    "unitLabel": "°"
  },
  "hoseWheelMmPerMagnet": {
    "displayName": "Distance Per Magnet",
    "description": "The distance of hose travel for each magnet reading on the hose wheel sensor.",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "hoseDiameterMm": {
    "displayName": "Diamètre du tuyau",
    "images": {
      "hose_diameter.png": {
        "caption": "Assurez-vous de mesurer le tuyau à son point le plus large."
      }
    },
    "instructions": {
      "1": "Mesurez le plus précisément possible le diamètre du tuyau de l'enrouleur.",
      "2": "Assurez-vous de mesurer le tuyau à son point le plus large. Dans l'image ci-dessous, l'agriculteur utilise ses index pour trouver le point le plus large du tuyau et utilise le mètre ruban pour tracer la ligne."
    },
    "unitLabel": {
      "metric": "mm",
      "us": "pouces"
    }
  },
  "i2cAddress": {
    "displayName": "Adresse I2C"
  },
  "installedOrientation": {
    "displayName": "Orientation installée"
  },
  "internalSoc": {
    "displayName": "Batterie interne Soc",
    "unitLabel": "%"
  },
  "ioPin": {
    "displayName": "Broche d'E/S"
  },
  "linearSpeedMmHMax": {
    "displayName": "Vitesse de rétraction maximale"
  },
  "linearSpeedMmHMin": {
    "displayName": "Vitesse de rétraction minimale"
  },
  "location": {
    "displayName": "Emplacement"
  },
  "maxTrackingPercentage": {
    "displayName": "Pourcentage de suivi maximal"
  },
  "milliRpmAvg": {
    "displayName": "RPM",
    "unitLabel": "RPM"
  },
  "milliRpmFast": {
    "displayName": "Seuil de vitesse (supérieur)",
    "unitLabel": "RPM"
  },
  "milliRpmSlow": {
    "displayName": "Seuil de vitesse (inférieur)",
    "unitLabel": "RPM"
  },
  "minTrackingPercentage": {
    "displayName": "Pourcentage de suivi minimum"
  },
  "mlPerPulse": {
    "displayName": "Volume par impulsion",
    "unitLabel": {
      "metric": {
        "long": "Litres",
        "short": "L"
      },
      "us": "fille"
    }
  },
  "nMagnets": {
    "description": "Combien d'aimants sont installés sur la bobine ? Pour les moulinets, ce nombre doit être compris entre 8 et 16",
    "displayName": "Nombre d'aimants installés",
    "images": {
      "magnet_installation_positions.png": {
        "caption": "Installation standard à 16 aimants"
      }
    },
    "optionLabel": "Aimants"
  },
  "nNozzles": {
    "description": "Combien de buses le moulinet utilise-t-il pour distribuer de l'eau ?",
    "displayName": "Nombre de buses",
    "images": {
      "irrigation_boom.png": {
        "caption": "Une rampe avec 12 buses."
      },
      "irrigation_gun.png": {
        "caption": "Un moulinet à pistolet avec une seule buse."
      }
    }
  },
  "nSats": {
    "displayName": "Qualité du signal"
  },
  "nWrapsOuterLayer": {
    "description": "Lorsque le tuyau est entièrement enroulé autour de la bobine, combien de tours sont visibles sur la couche la plus externe ?",
    "displayName": "Nombre d'enroulements de la couche extérieure",
    "images": {
      "reel_outer_hose_wraps.png": {
        "caption": "Une bobine avec 9 enroulements de couche extérieure.\n\nNotez que seuls les enroulements de tuyau à gauche et à droite du 9e enroulement ne sont pas comptés, même s'ils sont visibles car ils ne se trouvent pas sur la couche extérieure."
      }
    }
  },
  "flowRateOverrideLpm": {
    "displayName": "Débit forcé",
    "description": "Lorsqu'il est défini, ce débit mesuré est utilisé directement pour les calculs de l'historique d'irrigation au lieu d'être estimé à partir du diamètre de buse et de la pression.",
    "instructionsWithUnitLabel": "Saisissez le débit mesuré en {{unitLabel}}, ou laissez vide pour utiliser l'estimation basée sur le diamètre de buse.",
    "unitLabel": {
      "metric": {
        "long": "litres par minute",
        "short": "L/min"
      },
      "us": {
        "long": "gallons par minute",
        "short": "gal/min"
      }
    }
  },
  "nozzleDiameterMm": {
    "displayName": "Diamètre de la buse",
    "images": {
      "nozzle_diameter.png": {
        "altText": "Photo annotée illustrant la trajectoire de mesure du diamètre de la buse.",
        "caption": "Assurez-vous de mesurer l’ouverture de la buse à son point le plus large."
      }
    },
    "instructionsWithUnitLabel": "Mesurez la largeur intérieure de la buse en {{unitLabel}}",
    "note": "Assurez-vous de mesurer l’ouverture de la buse à son point le plus large.",
    "unitLabel": {
      "metric": {
        "long": "millimètres",
        "short": "mm"
      },
      "us": {
        "long": "pouces",
        "short": "dans"
      }
    }
  },
  "otaEnabled": {
    "displayName": "OTA activé"
  },
  "outerHoseWrapRadiusMm": {
    "description": "Le rayon d'enroulement extérieur du tuyau est la distance entre le centre de la bobine et le bord extérieur du tuyau lorsqu'il est entièrement enroulé.",
    "displayName": "Rayon d'enroulement du tuyau extérieur",
    "images": {
      "reel_outer_hose_wraps.png": {
        "altText": "Diagramme de mesure du rayon d'enroulement extérieur du tuyau."
      }
    },
    "instructions": {
      "introduction": "Pour déterminer cette mesure, effectuez l’une des opérations suivantes :",
      "options": {
        "1": "Si vous pouvez facilement déterminer où le bord extérieur du tuyau tomberait sur le côté extérieur de la bobine (voir l'image ci-dessous), mesurez la distance entre le centre de l'axe de la bobine et l'emplacement relatif du bord du tuyau.",
        "2": "Vous pouvez également regarder à l'intérieur de la bobine et mesurer la distance entre le bord extérieur de la bobine et le début du tuyau. Soustrayez cette distance de la distance entre le bord de la bobine et l'axe de la bobine."
      }
    },
    "unitLabel": {
      "metric": "mm",
      "us": "dans"
    }
  },
  "pidDerivativeCoeff": {
    "displayName": "Coefficient de dérivation PID"
  },
  "pidGainCoeff": {
    "displayName": "Coefficient de gain PID"
  },
  "pidIntegralCoeff": {
    "displayName": "Coefficient intégral PID"
  },
  "pidSensorSetpoint": {
    "displayName": "Point de consigne du capteur PID"
  },
  "pivotRadiusMeters": {
    "displayName": "Rayon de pivot",
    "unitLabel": {
      "metric": "Compteurs",
      "us": "Pieds"
    }
  },
  "pressureObservedKpa": {
    "displayName": "Pression",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "pressureReportsKpa": {
    "displayName": "Pression",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "rampSecondsRemaining": {
    "displayName": "Secondes restantes"
  },
  "rampSecondsTotal": {
    "displayName": "Nombre total de secondes"
  },
  "rateLpmAvg": {
    "displayName": "Débit moyen",
    "unitLabel": {
      "metric": "l/min",
      "us": "gallons/min"
    }
  },
  "rateLpmMax": {
    "displayName": "Débit max.",
    "unitLabel": {
      "metric": "l/min",
      "us": "gallons/min"
    }
  },
  "rateLpmMin": {
    "displayName": "Débit minimum",
    "unitLabel": {
      "metric": "l/min",
      "us": "gallons/min"
    }
  },
  "readingCelsius": {
    "displayName": "Température",
    "unitLabel": {
      "metric": "C°",
      "us": "F°"
    }
  },
  "readingKpa": {
    "displayName": "Pression",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "reportingPeriodEndDt": {
    "displayName": "Fin de la période de déclaration"
  },
  "reportingPeriodStartDt": {
    "displayName": "Début de la période de déclaration"
  },
  "relativePercentage": {
    "displayName": "Pourcentage relatif (%)",
    "unitLabel": {
      "metric": "%",
      "us": "%"
    }
  },
  "runDistanceMmCurrent": {
    "displayName": "Distance restante",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "runDistanceMmElapsed": {
    "displayName": "Distance parcourue",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "runDistanceMmMax": {
    "displayName": "Distance prolongée",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "runMagnetCountCurrent": {
    "displayName": "Courant de comptage des aimants"
  },
  "runMagnetCountMax": {
    "displayName": "Nombre d'aimants max."
  },
  "runSpeedMmpm": {
    "displayName": "Vitesse de course",
    "unitLabel": {
      "metric": "m/h",
      "us": "pieds/heure"
    }
  },
  "scheduledDeviceAction": {
    "displayName": "Action programmée de l'appareil"
  },
  "sensorModelId": {
    "displayName": "Modèle de capteur"
  },
  "sensorPort": {
    "description": "Les capteurs de bobine, de pression, de roue et de débit peuvent chacun être installés sur l'un des ports de capteur d'un appareil FarmHQ (générations FC2 et TC3 uniquement).",
    "displayName": "Port du capteur",
    "displayNameWithVal": "Port {{val}}",
    "fieldLabelWithSensorName": "Port du capteur {{sensorName}}",
    "images": {
      "enclosure_front.png": {
        "caption": "Ports de capteur 1 (milieu gauche) et 2 (milieu droit) sur un boîtier FarmHQ FC2."
      }
    },
    "values": {
      "port-1": "Port 1",
      "port-2": "Port 2"
    }
  },
  "sensorPriority": {
    "displayName": "Priorité du capteur"
  },
  "sensorTriggeredUpdate": {
    "displayName": "Mise à jour déclenchée par le capteur"
  },
  "signalQuality": {
    "displayName": "Qualité du signal"
  },
  "signalStrength": {
    "displayName": "Intensité du signal"
  },
  "speedMillirpm": {
    "displayName": "Vitesse de rotation",
    "unitLabel": "RPM"
  },
  "speedMmpm": {
    "displayName": "Vitesse",
    "unitLabel": {
      "metric": "m/h",
      "us": "pieds/heure"
    }
  },
  "speedObservedMmpm": {
    "displayName": "Vitesse",
    "unitLabel": {
      "metric": "m/h",
      "us": "pieds/heure"
    }
  },
  "speedReportsMmpm": {
    "displayName": "Vitesse",
    "unitLabel": {
      "metric": "m/h",
      "us": "pieds/heure"
    }
  },
  "speedMeasurementMethod": {
    "displayName": "Speed Measurement Method",
    "description": "Choose how reel speed is measured. 'Spool Rotation' calculates speed from spool geometry. 'Hose Wheel' measures the hose directly as it passes a sensor wheel.",
    "values": {
      "spool_rotation": "Spool Rotation",
      "hose_wheel": "Hose Wheel"
    }
  },
  "applicationType": {
    "displayName": "Type d'application",
    "description": "Ce que cet enrouleur applique au champ. Chaque passage de l'enrouleur est annoté avec ce type. La valeur par défaut est l'eau.",
    "values": {
      "water": "Eau",
      "manure": "Lisier",
      "other": "Autre"
    }
  },
  "sprinklerType": {
    "description": "Le choix de « Pistolet » ajoutera des embouts semi-circulaires aux bandes sur la carte d'état de l'appareil et sur la page Historique de l'irrigation du champ.",
    "displayName": "Type d'arroseur",
    "values": {
      "boom": "Boom",
      "gun": "Pistolet"
    }
  },
  "startRampPercentage": {
    "displayName": "Pourcentage de départ"
  },
  "stateCurrent": {
    "displayName": "État actuel"
  },
  "stateCurrentInitDt": {
    "displayName": "Dernier changement de statut"
  },
  "statePrevious": {
    "displayName": "Statut précédent"
  },
  "statePreviousInitDt": {
    "displayName": "Changement de statut précédent"
  },
  "stoppedTimeoutMs": {
    "displayName": "Délai d'arrêt de la roue",
    "description": "Durée pendant laquelle l'appareil attend sans détecter de mouvement de la roue avant de signaler la roue comme arrêtée.",
    "unitLabel": "min"
  },
  "swathWidthMm": {
    "descriptionWithUnitLabel": "Estimation de la largeur d'une ligne dans {{unitLabel}}. Pour les dévidoirs à pistolet, cela double également la distance à laquelle l'eau est pulvérisée par le pistolet.",
    "displayName": "Largeur d'andain",
    "placeholder": "Entrez la largeur de l'andain",
    "unitLabel": {
      "metric": "m",
      "us": "pieds"
    }
  },
  "switchType": {
    "helpBodyText": "Le réglage par défaut du commutateur indique si le commutateur est normalement ouvert ou normalement fermé.\n\nEn cas de doute, veuillez contacter le support FarmHQ.",
    "displayName": "Réglage par défaut du commutateur",
    "values": {
      "C": "fermé",
      "O": "ouvrir"
    }
  },
  "targetRampPercentage": {
    "displayName": "Pourcentage cible"
  },
  "threshold": {
    "displayName": "Seuil",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiLower": {
    "descriptionWithValue": "Tout ce qui est inférieur à {{value}} est trop bas.",
    "displayName": "Seuil inférieur",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiUpper": {
    "descriptionWithValue": "Tout ce qui est supérieur à {{value}} est trop élevé.",
    "displayName": "Seuil supérieur",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "voltageChangeMvPerHour": {
    "displayName": "Changement de tension"
  },
  "voltageIntercept": {
    "displayName": "Interception de tension"
  },
  "voltageMv": {
    "displayName": "Tension",
    "unitLabel": "V"
  },
  "voltageSlope": {
    "displayName": "Pente de tension"
  },
  "voltageThresholdLowMv": {
    "displayName": "Seuil de tension inférieur",
    "unitLabel": "Volts"
  },
  "volumeLFinal": {
    "displayName": "Volume Final",
    "unitLabel": {
      "metric": "l",
      "us": "fille"
    }
  },
  "volumeLInitial": {
    "displayName": "Volume initial",
    "unitLabel": {
      "metric": "l",
      "us": "fille"
    }
  },
  "volumeLTotal": {
    "displayName": "Volume total",
    "unitLabel": {
      "metric": "l",
      "us": "fille"
    }
  },
  "widthMm": {
    "displayName": "Largeur de la bobine",
    "images": {
      "reel_width.png": {
        "caption": "Diagramme de largeur de bobine."
      }
    },
    "instructions": "Mesurer la distance entre les parois de la bobine.",
    "unitLabel": {
      "metric": "mm",
      "us": "dans"
    }
  }
}
